"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = exports.Body = exports.Paper = exports.Backdrop = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Backdrop = _styledComponents["default"].div.withConfig({
  displayName: "ModalSliderstyle__Backdrop",
  componentId: "z0jefn-0"
})(function (_ref) {
  var color = _ref.theme.color,
      show = _ref.show;
  return {
    display: show ? 'block' : 'none',
    position: 'fixed',
    overflow: 'auto',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    background: color.background.dark,
    zIndex: 2000
  };
});

exports.Backdrop = Backdrop;

var Paper = _styledComponents["default"].div.withConfig({
  displayName: "ModalSliderstyle__Paper",
  componentId: "z0jefn-1"
})(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      color = _ref2$theme.color,
      border = _ref2$theme.border,
      spacing = _ref2$theme.spacing,
      breakpoint = _ref2$theme.breakpoint;
  return _defineProperty({
    background: color.neutral['08'],
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    height: 'auto',
    maxHeight: "calc(100vh - ".concat(spacing.inline.md, ")")
  }, breakpoint.lg(), {
    borderRadius: "".concat(border.radius.sm, "px 0 0 ").concat(border.radius.sm, "px"),
    width: '700px',
    maxWidth: "calc(100% - ".concat(spacing.inline.md, ")"),
    left: 'initial',
    maxHeight: '100vh',
    height: '100vh'
  });
});

exports.Paper = Paper;

var Body = _styledComponents["default"].div.withConfig({
  displayName: "ModalSliderstyle__Body",
  componentId: "z0jefn-2"
})(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      spacing = _ref4$theme.spacing,
      breakpoint = _ref4$theme.breakpoint;
  return _defineProperty({
    overflow: 'auto',
    padding: spacing.squeeze.sm,
    textAlign: 'center',
    boxSizing: 'border-box',
    maxHeight: "calc(100vh - ".concat(spacing.inline.md, ")")
  }, breakpoint.lg(), {
    maxHeight: '100vh',
    padding: '120px 224px 80px 104px',
    textAlign: 'left'
  });
});

exports.Body = Body;
var CloseButton = (0, _styledComponents["default"])(_.IconButton).withConfig({
  displayName: "ModalSliderstyle__CloseButton",
  componentId: "z0jefn-3"
})(function (_ref6) {
  var _ref6$theme = _ref6.theme,
      spacing = _ref6$theme.spacing,
      breakpoint = _ref6$theme.breakpoint;
  return _defineProperty({
    transform: 'translateY(-50%)',
    position: 'absolute',
    top: 0,
    right: spacing.inline['3xs']
  }, breakpoint.lg(), {
    transform: 'translateX(-50%)',
    top: spacing.inline['6xl'],
    left: 0,
    right: 'initial'
  });
});
exports.CloseButton = CloseButton;